module.exports = __webpack_public_path__ + "img/brn_team.f5f0636d.png";